export default __webpack_public_path__ + "static/media/wa-1717-1.9acbffa1.jpg";